export class AuditedEntity {
  public createdAt: Date

  public modifiedAt: Date

  public createdBy: string

  public modifiedBy: string
}
